import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CodeService {
  private apiURL = environment.api;

  constructor(private http: HttpClient) { }

  /**
   * Process the import - send CSV content and field mappings to server
   * Server will store in temp, process, and delete
   */
  processImport(importData: any): Observable<any> {
    return this.http.post(this.apiURL + 'setting/code/import', importData);
  }
}
